<div class="containerDialog">
  <!-- LOADING LOADER -->
  <div
    *ngIf="isLoadingReviews"
    class="loader-container"
    style="display: flex; flex-direction: column; height: 100%"
  >
    <div
      class="titleSection"
      style="
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
      "
    >
      <h4 class="titleModal" style="margin: 0; color: #4b5563">
        Revisión de Atención al Cliente
      </h4>
    </div>

    <div style="display: flex; flex-direction: column; gap: 16px; flex: 1">
      <div
        style="
          width: 100%;
          height: 110px;
          background: #f9fafb;
          border-radius: 8px;
        "
      ></div>
      <div
        style="
          width: 100%;
          height: 110px;
          background: #f9fafb;
          border-radius: 8px;
        "
      ></div>
      <div
        style="
          width: 100%;
          height: 110px;
          background: #f9fafb;
          border-radius: 8px;
        "
      ></div>
      <div
        style="
          width: 100%;
          height: 110px;
          background: #f9fafb;
          border-radius: 8px;
        "
      ></div>
    </div>

    <div
      class="containerButtons"
      style="margin-top: 20px; display: flex; justify-content: flex-end"
    >
      <button class="buttonSecundary" (click)="close()">Cerrar</button>
    </div>
  </div>

  <ng-container *ngIf="!isLoadingReviews">
    <div
      class="titleSection"
      style="display: flex; justify-content: space-between; align-items: center"
    >
      <div style="display: flex; flex-direction: column; gap: 4px">
        <h4 class="titleModal" style="margin: 0">
          {{
            reviews.length > 0 && isEditing && isBiblia
              ? "Editar Revisión de Atención al Cliente"
              : "Revisión de Atención al Cliente"
          }}
        </h4>
        <p class="subtitleModal">
          Estas revisiones son realizadas por el área de Atención al Cliente de
          Biblia, para ser absueltas, el área de programación debe resolverlas
          primero y posteriormente biblia podrá aprobarlas o desaprobarlas.
        </p>
      </div>
      <button
        mat-icon-button
        (click)="refreshReviews()"
        [disabled]="isLoadingReviews"
        title="Actualizar"
      >
        <mat-icon>refresh</mat-icon>
      </button>
    </div>

    <ng-container *ngIf="!isEditing && reviews.length > 0">
      <div class="containerTitle">
        <div
          class="status-badge"
          [ngClass]="{
            approvedIcon: isAllApproved,
            regularizeIcon: !isAllApproved
          }"
        >
          <i-tabler name="alert-circle" *ngIf="!isAllApproved"></i-tabler>
          <i-tabler name="circle-check" *ngIf="isAllApproved"></i-tabler>
          <span>{{
            isAllApproved
              ? "La información fue regularizada"
              : "Esta información requiere regularización"
          }}</span>
        </div>

        <div class="action-icons" *ngIf="isBiblia">
          <i-tabler
            name="pencil"
            class="review-pill-icon icon-color"
            (click)="isEditing = true"
          ></i-tabler>
          <i-tabler
            name="trash"
            class="review-pill-icon icon-color"
            (click)="deleteCsReview()"
          ></i-tabler>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="isBiblia">
      <!-- EDIT MODE -->
      <ng-container *ngIf="isEditing || reviews.length === 0">
        <div class="form-section">
          <label>Fecha de Revisión <span class="required">*</span></label>
          <input
            type="date"
            class="form-control mb-3"
            [value]="currentDate"
            disabled
          />

          <label
            >¿La información es correcta? <span class="required">*</span></label
          >
          <div class="approvalSelection">
            <label class="approvalOption">
              <input
                type="radio"
                name="approval"
                [value]="true"
                [(ngModel)]="isRegularized"
              />
              <span class="circle"></span>
              Si, todo está correcto.
            </label>
            <label class="approvalOption">
              <input
                type="radio"
                name="approval"
                [value]="false"
                [(ngModel)]="isRegularized"
              />
              <span class="circle"></span>
              No, necesita regularizaciones.
            </label>
          </div>

          <div class="commentSection">
            <label for="description"
              >Descripción de Revisión <span class="required">*</span></label
            >
            <textarea
              id="description"
              [(ngModel)]="description"
              placeholder="Ingresa tu comentario"
              rows="4"
              style="min-height: 4em; overflow: hidden; resize: none"
            ></textarea>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="isProgramacion || isBiblia">
      <ng-container *ngIf="reviews.length === 0 && isProgramacion">
        <div class="obs-empty">
          <i-tabler name="inbox" class="obs-empty-icon"></i-tabler>
          <p class="obs-empty-title">¡Nada por aquí!</p>
          <p class="obs-empty-subtitle">
            Aún no se ha revisado el file en Biblia, cuando se haga la revisión
            podrás verla aquí.
          </p>
        </div>
      </ng-container>

      <ng-container *ngIf="reviews.length > 0 && !isEditing">
        <div class="obs-list">
          <div
            *ngFor="let review of reviews"
            class="obs-card"
            [ngClass]="{
              'border-gray':
                review.incidentStatus === this.INCIDENT_STATUS.PENDING ||
                review.incidentStatus === this.INCIDENT_STATUS.RESOLVED,
              'border-green':
                review.incidentStatus === this.INCIDENT_STATUS.APPROVED,
              'border-red':
                review.incidentStatus === this.INCIDENT_STATUS.NOT_APPROVED
            }"
          >
            <div class="obs-card-header">
              <h3
                class="obs-card-title"
                [ngClass]="{
                  'text-orange':
                    review.incidentStatus === this.INCIDENT_STATUS.PENDING,
                  'text-green':
                    review.incidentStatus === this.INCIDENT_STATUS.RESOLVED ||
                    review.incidentStatus === this.INCIDENT_STATUS.APPROVED,
                  'text-red':
                    review.incidentStatus === this.INCIDENT_STATUS.NOT_APPROVED
                }"
              >
                {{ review.activityDay }} - {{ review.activityName }}
              </h3>
            </div>
            <p
              class="obs-card-desc"
              [ngClass]="{
                'border-left-orange':
                  review.incidentStatus === this.INCIDENT_STATUS.PENDING,
                'border-left-green':
                  review.incidentStatus === this.INCIDENT_STATUS.RESOLVED ||
                  review.incidentStatus === this.INCIDENT_STATUS.APPROVED,
                'border-left-red':
                  review.incidentStatus === this.INCIDENT_STATUS.NOT_APPROVED
              }"
            >
              {{ review.description }}
            </p>
            <div class="obs-card-footer">
              <div class="obs-pill" *ngIf="review.destination">
                <i-tabler name="map-pin" class="obs-pill-icon"></i-tabler>
                {{ review.destination }}
              </div>
              <div class="obs-pill" *ngIf="review.incidentDate">
                <i-tabler
                  name="calendar-event"
                  class="obs-pill-icon"
                ></i-tabler>
                {{ review.incidentDate | date: "dd/MM/yy" }}
              </div>
              <div
                class="obs-pill"
                *ngIf="review.incidentStatus !== this.INCIDENT_STATUS.PENDING"
                [ngClass]="{
                  'obs-pill-light-green':
                    review.incidentStatus === this.INCIDENT_STATUS.RESOLVED ||
                    review.incidentStatus === this.INCIDENT_STATUS.APPROVED,
                  'obs-pill-light-red':
                    review.incidentStatus === this.INCIDENT_STATUS.NOT_APPROVED
                }"
              >
                <i-tabler
                  *ngIf="
                    review.incidentStatus === this.INCIDENT_STATUS.RESOLVED
                  "
                  name="circle-check"
                  class="obs-pill-icon"
                ></i-tabler>
                <i-tabler
                  *ngIf="
                    review.incidentStatus === this.INCIDENT_STATUS.APPROVED
                  "
                  name="circle-check"
                  class="obs-pill-icon"
                ></i-tabler>
                <i-tabler
                  *ngIf="
                    review.incidentStatus === this.INCIDENT_STATUS.NOT_APPROVED
                  "
                  name="circle-x"
                  class="obs-pill-icon"
                ></i-tabler>

                <span
                  *ngIf="
                    review.incidentStatus === this.INCIDENT_STATUS.RESOLVED
                  "
                  >Resuelto por {{ review.resolvedBy }}</span
                >
                <span
                  *ngIf="
                    review.incidentStatus === this.INCIDENT_STATUS.APPROVED
                  "
                  >Aprobado por {{ review.approvedBy }}</span
                >
                <span
                  *ngIf="
                    review.incidentStatus === this.INCIDENT_STATUS.NOT_APPROVED
                  "
                  >No Aprobado por {{ review.notApprovedBy }}</span
                >
              </div>

              <div class="obs-card-actions">
                <ng-container *ngIf="isBiblia">
                  <ng-container
                    *ngIf="
                      review.incidentStatus === this.INCIDENT_STATUS.APPROVED
                    "
                  >
                    <i-tabler
                      name="circle-check-filled"
                      style="
                        width: 14px;
                        height: 14px;
                        stroke-width: 3;
                        color: green !important;
                      "
                    ></i-tabler>
                  </ng-container>

                  <ng-container
                    *ngIf="
                      review.incidentStatus ===
                      this.INCIDENT_STATUS.NOT_APPROVED
                    "
                  >
                    <div class="action-icon-solid-red">
                      <i-tabler
                        name="circle-x-filled"
                        style="
                          width: 14px;
                          height: 14px;
                          stroke-width: 3;
                          color: red !important;
                        "
                      ></i-tabler>
                    </div>
                  </ng-container>

                  <div
                    *ngIf="
                      review.incidentStatus === this.INCIDENT_STATUS.RESOLVED
                    "
                    style="display: flex; align-items: center; gap: 12px"
                  >
                    <mat-spinner
                      *ngIf="loadingStatusId === review.id"
                      diameter="24"
                    ></mat-spinner>
                    <ng-container *ngIf="loadingStatusId !== review.id">
                      <i-tabler
                        name="progress-check"
                        matTooltip="Aprobar revisión"
                        matTooltipPosition="above"
                        class="obs-action-icon"
                        style="cursor: pointer; color: #4caf50 !important"
                        (click)="
                          updateReviewStatus(review, INCIDENT_STATUS.APPROVED)
                        "
                      ></i-tabler>
                      <i-tabler
                        name="circle-x"
                        class="obs-action-icon"
                        style="cursor: pointer; color: #f44336 !important"
                        matTooltip="Rechazar revisión"
                        matTooltipPosition="above"
                        (click)="
                          updateReviewStatus(
                            review,
                            INCIDENT_STATUS.NOT_APPROVED
                          )
                        "
                      ></i-tabler>
                    </ng-container>
                  </div>
                </ng-container>

                <div
                  *ngIf="
                    isProgramacion &&
                    review.incidentStatus !== this.INCIDENT_STATUS.APPROVED
                  "
                >
                  <mat-spinner
                    *ngIf="loadingStatusId === review.id"
                    diameter="24"
                  ></mat-spinner>
                  <ng-container *ngIf="loadingStatusId !== review.id">
                    <i-tabler
                      *ngIf="
                        review.incidentStatus === this.INCIDENT_STATUS.RESOLVED
                      "
                      matTooltip="Resuelto, ¿marcar como Pendiente?"
                      matTooltipPosition="above"
                      name="square-check-filled"
                      style="
                        width: 24px;
                        height: 24px;
                        stroke-width: 3;
                        color: #4caf50 !important;
                        cursor: pointer;
                      "
                      (click)="toggleReviewStatusProgramacion(review)"
                    ></i-tabler>
                    <i-tabler
                      *ngIf="
                        review.incidentStatus !== this.INCIDENT_STATUS.RESOLVED
                      "
                      matTooltip="Pendiente, ¿marcar como Resuelto?"
                      matTooltipPosition="above"
                      name="square"
                      class="obs-action-icon"
                      style="cursor: pointer"
                      (click)="toggleReviewStatusProgramacion(review)"
                    ></i-tabler>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <div class="containerButtons">
      <ng-container *ngIf="isBiblia">
        <button
          class="buttonSecundary"
          (click)="isEditing && isRegularized !== null ? cancelEdit() : close()"
        >
          {{ isEditing && isRegularized !== null ? "Cancelar" : "Cerrar" }}
        </button>
        <button
          *ngIf="isEditing || isRegularized === null"
          class="buttonPrimary"
          [disabled]="
            isRegularized === null ||
            !description ||
            (!isEditing ? false : !hasChanges()) ||
            isSaving
          "
          [class.disabled]="
            isRegularized === null ||
            !description ||
            (!isEditing ? false : !hasChanges()) ||
            isSaving
          "
          (click)="saveCsReviewBiblia()"
        >
          <span *ngIf="isSaving">Cargando...</span>
          <span *ngIf="!isSaving">Guardar</span>
        </button>
      </ng-container>

      <ng-container *ngIf="!isBiblia">
        <button class="buttonSecundary" (click)="close()">Cerrar</button>
      </ng-container>
    </div>
  </ng-container>
</div>
